
// 定义超时时间
export const TIMEOUT = 60000;

// 定义不同环境下的url，开发环境和线上环境不同。
const devBaseUrl = "http://dev.xiebingli.top";
const proBaseUrl = "https://" + window.location.hostname; // 主域名地址
export const baseUrl = process.env.NODE_ENV === 'production' ? proBaseUrl : devBaseUrl;

const isProEvn = process.env.NODE_ENV === 'production' ? true : false;
export const withCredentials = !isProEvn;

/**
 * 基础字符串响应。
 */
export interface BasicResponse {
    code: number,
    message: string
    data: string
}

/**
 * 基础配置信息响应
 */
export interface BasicDataResponse<T> {
    code: number,
    message: string
    data: T
}


/**
 * 保存结果结构体
 */
export interface SaveRes {
    message: string,
    errorMsg?: string
}

/**
 * 提交默认操作
 */
export enum SUBMIT_TYPE {
    TYPE_CREATE = 0,
    TYPE_SAVE_DRAFT = 1,
    TYPE_MODIFY = 2,
}

/**
 * 用户信息
 */
export interface User {
    id: number,
    name: string,
    password: string
    isAdmin: boolean   // 是否是管理员
    errorTimes:number // 登录错误次数
}

/**
 * 用户列表响应
 */
export interface UserListResponse {
    total: number,
    data: User[]
}
